import { AboutMe, ProjectContainer } from "components";

export const Main = () => {
  return (
    <div className="m-auto">
      <AboutMe />
      <ProjectContainer />
    </div>
  );
};
